// extracted by mini-css-extract-plugin
export default {"product__types":"ProductTypes_product__types__bAi8q","input":"ProductTypes_input__myJO8"};